import Vue from 'vue'
import Vuex from 'vuex'

import { createActions } from './actions'
import mutations from './mutations'
import fileFunctions from '@main/js/store/modules/fileFunctions'
import fileBrowser from '@main/js/store/modules/fileBrowser'
import userAuth from '@main/js/store/modules/userAuth'
import profile from '@account/js/modules/profile'
import auth from '@main/js/store/modules/auth'
import company from '@companies/js/modules/company'
import services from '@services/js/modules/services'
import form from '@services/js/modules/form'
import app from '@main/js/store/modules/app'
import checkout from '@checkout/js/modules/checkout'
import checkoutAddress from '@checkout/js/modules/address'
import paymentMethods from '@checkout/js/modules/payment-methods'
import order from '@checkout/js/modules/order'
import basket from '@basket/js/modules/basket'
import orders from '@orders/js/modules/orders'
import tenders from '@tenders/js/modules/tenders'
import tenderForm from '@tenders/js/modules/tenderForm'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export function createStore() {
  return new Vuex.Store({
    modules: {
      fileFunctions,
      fileBrowser,
      userAuth,
      profile,
      auth,
      company,
      services,
      form,
      checkout,
      order,
      checkoutAddress,
      paymentMethods,
      basket,
      orders,
      tenders,
      tenderForm,
      app,
    },
    state: {},
    mutations,
    strict: false,
  })
}
